import { render, staticRenderFns } from "./NTOPlantsMap.vue?vue&type=template&id=f4c0fa4e&"
import script from "./NTOPlantsMap.vue?vue&type=script&lang=js&"
export * from "./NTOPlantsMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports